<template>
  <div style="width: 100%; margin-bottom: 10px">
    <div
      class="list-usaha"
      v-for="(list, indexList) in listInput"
      :key="indexList + 10000"
      style="margin-bottom: 0 !important"
    >
      <div
        v-for="(listHead, indexListHead) in list.head"
        :key="indexListHead + 1"
      >
        <div
          class="list-usaha-content list-usaha-content__title"
          style="margin-bottom: 0 !important; padding: 3px !important"
        >
          <div
            v-for="(table, indexTable) in tables"
            :key="indexTable"
            :class="table.css"
            style="text-align: center"
          >
            {{ listHead[table.title] }}
          </div>
        </div>
      </div>
      <div
        v-for="(listItem, indexListItem) in list.item"
        :key="indexListItem + 1000"
      >
        <BlockLabelGray
          :label="listItem.label"
          v-if="listItem.type == 'label'"
        />
        <div style="display:flex;" v-else>
          <div
            v-for="(table, indexTable) in tables"
            :key="indexTable + 100"
            :class="`${table.css} desc-table`"
          >
            <div v-if="Array.isArray(listItem[table.desc])">
              <p
                v-for="(arr, indexArr) in listItem[table.desc]"
                :key="indexArr"
              >
                {{ arr }}
              </p>
            </div>
            <span v-else>{{ listItem[table.desc] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BlockLabelGray from './forms/label/blockLabel-gray.vue'
export default {
  props: [
    'label',
    'isRequired',
    'tables',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'listInput',
  ],
  components: { BlockLabelGray },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {},
  methods: {},
}
</script>
<style scoped>
.desc-table {
  border: 1px solid rgba(128, 128, 128, 0.5);
  background-color: rgba(128, 128, 128, 0.1);
  padding: 5px;
  height: auto !important;
}
</style>
